import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createRefundApplication, CreateRefundApplicationData } from "@/http/refundApplicationsApi";
import { getRefundApplicationsQueryKey } from "@/utils/queryKeys";

interface CreateRefundApplicationParams {
  phone: string;
  data: CreateRefundApplicationData;
  clubId?: string;
}

export const useCreateRefundApplicationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ phone, data, clubId }: CreateRefundApplicationParams) => {
      const response = await createRefundApplication(phone, data, clubId);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getRefundApplicationsQueryKey(),
      });
    },
  });
};
